import { ENDPOINTS } from "./constants";

const validateRequest = (endpoint) => {
  if (!Object.values(ENDPOINTS).includes(endpoint)) {
    return {
      isValid: false,
      errorMessage: `unsupported endpoint ${endpoint}`,
    };
  }

  return {
    isValid: true,
  };
};

export default validateRequest;
